var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'country-flag d-flex justify-center align-center mx-1 ' + (_vm.active ? 'active' : ''),on:{"click":function($event){return _vm.$emit('flag-click')}}},[_c('img',{staticClass:"border-radius-1",attrs:{"src":`${_vm.$utils.globalConstants.BASE_ASSETS_URL}/countries_flags/${_vm.iso_code}.png`,"alt":" country-flag"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }